import Marquee from "react-fast-marquee";

const items = ["Weddings", "Chester", "Cheshire", "North Wales", "Portraits", "Natural & Relaxed", "Since 2004"];

export const EditorialMarquee = ({ dark = false }) => (
  <section
    data-testid="editorial-marquee"
    className={`py-8 md:py-12 border-y ${dark ? "bg-ink border-paper/10" : "bg-paper border-ink/5"}`}
    aria-hidden="true"
  >
    <Marquee speed={40} gradient={false}>
      {items.concat(items).map((t, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-serif italic text-4xl md:text-6xl ${dark ? "text-paper/50" : "text-ink/40"}`}>
            {t}
          </span>
          <span className={`mx-8 md:mx-14 text-2xl ${dark ? "text-sand/50" : "text-sand"}`}>✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
